import React from "react";
import { Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import styles from "../PublishTrip.module.css";
import TripDateCard from "./TripDateCard";

const TripDatesListSection = ({
  tripDates,
  onEdit,
  onDelete,
  canDeleteTripDate,
  getCoverageLabel,
}) => {
  const { t } = useTranslation();
  const sortedTripDates = [...tripDates]
    .map((tripDate, originalIndex) => ({ tripDate, originalIndex }))
    .sort((a, b) => {
      const aStart = new Date(a.tripDate?.startDate || 0).getTime();
      const bStart = new Date(b.tripDate?.startDate || 0).getTime();
      if (aStart !== bStart) return aStart - bStart;

      const aEnd = new Date(a.tripDate?.endDate || 0).getTime();
      const bEnd = new Date(b.tripDate?.endDate || 0).getTime();
      return aEnd - bEnd;
    });

  return (
    <div className={`${styles.section} ${styles.instancesSection}`}>
      <Text as="h2" className={styles.sectionTitle} weight="semibold">
        {t("tripPublication.publishTrip.sections.instances")}
      </Text>

      {tripDates.length === 0 && (
        <Text as="p" className={styles.emptyHint}>
          {t("tripPublication.publishTrip.empty.noDepartureInstance")}
        </Text>
      )}

      {sortedTripDates.map(({ tripDate, originalIndex }, index) => (
        <TripDateCard
          key={tripDate.id || `${tripDate.startDate}-${originalIndex}`}
          tripDate={tripDate}
          index={index}
          coverageLabel={getCoverageLabel(tripDate)}
          onEdit={() => onEdit(originalIndex)}
          onDelete={() => onDelete(originalIndex)}
          canDelete={canDeleteTripDate}
        />
      ))}
    </div>
  );
};

export default TripDatesListSection;
